import { useState, useCallback } from 'react';
import { urgencyScarcityApi } from '../api/urgencyScarcity';
import type { UrgencyScarcitySettings } from '../api/urgencyScarcity';

export function useUrgencyScarcity() {
  const [settings, setSettings] = useState<UrgencyScarcitySettings | null>(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await urgencyScarcityApi.show();
      setSettings(res.data.data);
    } catch (err: any) {
      setError(err?.message ?? 'Failed to load urgency & scarcity bar settings.');
    } finally {
      setLoading(false);
    }
  }, []);

  const save = useCallback(async (next: UrgencyScarcitySettings) => {
    setSaving(true);
    setError(null);
    try {
      const res = await urgencyScarcityApi.update(next);
      setSettings(res.data.data);
      return res.data.data;
    } catch (err: any) {
      setError(err?.message ?? 'Failed to save urgency & scarcity bar settings.');
      return null;
    } finally {
      setSaving(false);
    }
  }, []);

  return { settings, loading, saving, error, fetchSettings, save, setError };
}
